<div class="popup-overlay-camera modal-confirm confiram-fail">
  <div class="popup-warp">
      <div class="popup-inner pad-popup">
          <div class="content-popup">
              <div class="icon-popup"><img src="assets/img/unilever-icon.png"></div>
              <p *ngIf="tryAgain" class="des-popup">{{giftName}}</p>
              <p *ngIf="!tryAgain" class="des-popup">Chúc mừng bạn đã nhận được 1 {{giftName}}</p>
              <div style="text-align: center">
                <img style="width: 50%;" [src]="giftImage"/>
              </div>
              <div class="group-btn-inline btn-center">
                  <button type="button" class="btn btn-confirm" (click)="close()">Đóng</button>
              </div>
          </div>
      </div>
  </div>
</div>